import { render, staticRenderFns } from "./AboutUS.vue?vue&type=template&id=66fe7ad6&scoped=true&"
import script from "./AboutUS.vue?vue&type=script&lang=js&"
export * from "./AboutUS.vue?vue&type=script&lang=js&"
import style0 from "./AboutUS.vue?vue&type=style&index=0&id=66fe7ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fe7ad6",
  null
  
)

export default component.exports